import React from 'react';

import FormikFileUpload from 'components/formik/FormikFileUpload';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import { generateUploadFileList, getFileUploadMessages } from 'utils/fileUtils';
import adminApiClient, { ResourceDownloadResponse } from 'api/adminApiClient';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];

const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

const uploadFilesLinkFunction =
  adminApiClient.getOnboardingDocumentationUploadLink.bind(adminApiClient);

type Props = {
  fieldName: string;
  files?: ResourceDownloadResponse[];
};

export default React.memo((props: Props) => {
  const { fieldName, files } = props;
  const defaultFileNames = files?.length ? generateUploadFileList(files) : [];

  return (
    <FormikFileUpload
      name={fieldName}
      isDraggable
      maxFileCount={3}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      defaultFileList={defaultFileNames}
      messages={fileUploadMessages}
      uploadLinkFunction={uploadFilesLinkFunction}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
